module.exports = __webpack_public_path__ + "static/media/new_note_icon.89bcaac2.svg";